<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Why didn’t I get a say in the amount of compensation?<Caret /></summary>
  <p>
    The settlement was signed off by the Claimant Committee acting as agent for all clients after receiving our advice
    and under the powers given to them in the Litigation Management Agreement. The committee is set up to ensure
    efficient management of the case including reducing the administration and costs involved in taking instructions
    from thousands of individuals.
  </p>
</details>
